import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import {HeoMoneyi18nProvider} from './_heomoney/i18n/HeoMoneyi18n'

import './_heomoney/assets/sass/style.scss'
import './_heomoney/assets/sass/plugins.scss'
import './_heomoney/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import {DataContext} from './app/modules/catalogo/ContextoCatalogo/DataContext'
import {DataContextId} from './app/modules/widgets/DataContext/DataContext'

setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <HeoMoneyi18nProvider>
        <AuthProvider>
          <DataContextId>
            <DataContext>
              <AppRoutes />
            </DataContext>
          </DataContextId>
        </AuthProvider>
      </HeoMoneyi18nProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  )
}
